import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, setValue } from 'react-hook-form';
import * as actions from '../actions/communicationmoduleactions'
import UserEntryDocumentsUpload from '../components/UserEntryDocumentsUpload'


export default function UseEntryDetails() {


    const state = useSelector(state => state.communicationModuleReducer)
    let userEntryDetails = state.userEntryDetails;
    let masters = state.masters;
    let userEntry = state.userEntry;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { register: registerUseEntryDetails,
        reset: resetUseEntryDetails, handleSubmit: submitUseEntryDetails, setValue: setUseEntryDetailsValue, formState: { errors: errorUseEntryDetails } } = useForm();
    useEffect(() => {
        try {
            dispatch(actions.getCommunicationModuleMastersForUserEntry());
            dispatch(actions.getCommunicationMasterForUserEntry(state?.userEntry.mcId, state?.userEntry.linkId));

        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [dispatch]);
    useEffect(() => {
        let valuesToMap = [
            { "userMobileNo": userEntryDetails.userMobileNo },
            { "userName": userEntryDetails.userName },
            { "userEmail": userEntryDetails.userEmail },
            { "userProductTypeId": userEntryDetails.userProductTypeId },
            { "userSserviceTypeId": userEntryDetails.userSserviceTypeId },
            { "userRemarks": userEntryDetails.userRemarks },
            { "termsCheckbox": userEntryDetails.termsCheckbox },
            { "vehCategory": userEntryDetails.vehCategory },
            { "vehType": userEntryDetails.vehType },
            { "isVehicleFinanced": userEntryDetails.isVehicleFinanced },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setUseEntryDetailsValue(key, i[key])));
    }, [userEntryDetails]);
    const onUseEntryDetailsSubmit = async (data, e) => {
        if (userEntryDetails.termsCheckbox != "Y") {
            alert("Accept terms and Conditions.");
            return;
        }
        dispatch(actions.saveCommunicationMaster());

    }
    const onFinalSubmit = async (data, e) => {
        dispatch(actions.submitCommunicationMaster(state?.userEntry.mcId, state?.userEntry.linkId));

    }
    const onErrorUseEntryDetails = (errorUseEntryDetails, e) => console.log(errorUseEntryDetails, e);
    const onChangeUseEntryDetailsParams = async(e) => {
        let { name, value, checked } = e.target;
        if (name == "termsCheckbox") {

            let value = checked == true ? "Y" : "N";
           await dispatch(actions.onChangeUserEntryDetailsParams({ name, value }));
        } else {

           await dispatch(actions.onChangeUserEntryDetailsParams({ name, value }));
        }
        if(name =="vehCategory" ||name =="isVehicleFinanced" ||name =="vehType" )
        {
          await  dispatch(actions.onUpdateDocumentsListFront());
               
        }
    }
    /*
    
    export const COMM_PRODUCT_TYPE_MOTOR=982;
    export const COMM_SERVICE_TYPE_MOTOR_NEW_INSURANCE=2;
    export const COMM_SERVICE_TYPE_MOTOR_RENEWAL=3;
    
    */
    let UserMobileNo = <input className={errorUseEntryDetails.userMobileNo ? 'form-control  is-invalid' : 'form-control'}
        name="userMobileNo"
        id="userMobileNo"
        disabled={true}
        type="text"
        placeholder="User Mobile No"
        {...registerUseEntryDetails("userMobileNo", { required: false, onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    />
    let UserName = <input className={errorUseEntryDetails.userName ? 'form-control  is-invalid' : 'form-control'}
        name="userName"
        id="userName"
        disabled={false}
        type="text"
        placeholder="User Name"
        {...registerUseEntryDetails("userName", { required: true, onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    />
    let UserEmail = <input className={errorUseEntryDetails.userEmail ? 'form-control  is-invalid' : 'form-control'}
        name="userEmail"
        id="userEmail"
        disabled={false}
        type="text"
        placeholder="User Email"
        {...registerUseEntryDetails("userEmail", {
            required: true,
            required: "Email is required",
            pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email address"
            },
            onChange: (e) => onChangeUseEntryDetailsParams(e)
        })}
    />
    let UserProductTypeId = <select className={errorUseEntryDetails.userProductTypeId ? 'form-select  is-invalid' : 'form-select'}
        name="userProductTypeId"
        data-toggle="select2"
        id="userProductTypeId"
        disabled={true}
        {...registerUseEntryDetails("userProductTypeId", { required: false, onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    >
        <option value=''>---- Select ---- -</option>
        {masters.productsList && masters.productsList.map((applyType) => (
            <option value={applyType.domainValue} key={applyType.domainValue}>
                {applyType.domainValueName}
            </option>))}
    </select>
    let UserSserviceTypeId = <select className={errorUseEntryDetails.userSserviceTypeId ? 'form-select  is-invalid' : 'form-select'}
        name="userSserviceTypeId"
        data-toggle="select2"
        id="userSserviceTypeId"
        disabled={true}
        {...registerUseEntryDetails("userSserviceTypeId", { required: false, onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    >
        <option value=''>---- Select ---- -</option>
        {masters.productServiceLink && masters.productServiceLink.map((applyType) => (
            <option value={applyType.serviceTypeId} key={applyType.serviceTypeId}>
                {applyType.serviceTypeName}
            </option>))}
    </select>
    let UserRemarks = <textarea className={errorUseEntryDetails.userRemarks ? 'form-control  is-invalid' : 'form-control'}
        name="userRemarks"
        id="userRemarks"
        disabled={false}
        type="text"
        placeholder="User Remarks"
        {...registerUseEntryDetails("userRemarks", { required: true, onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    />
    let TermsandConditions =
        <input
            type="checkbox"
            id="termsCheckbox"
            className={`form-check-input ${errorUseEntryDetails.termsCheckbox ? 'is-invalid' : 'form-check-input'}`}
            name="checkbox"
            style={{ width: "15px", height: "15px" }}
            checked={userEntryDetails.termsCheckbox == "Y"}
            value={userEntryDetails.termsCheckbox}
            {...registerUseEntryDetails("termsCheckbox", {
                required: false,
                onChange: (e) => onChangeUseEntryDetailsParams(e)
            })}
        />
    let UserVehType = <select className={errorUseEntryDetails.vehType ? 'form-select  is-invalid' : 'form-select'}
        name="vehType"
        data-toggle="select2"
        id="vehType"
        //disabled={true}
        {...registerUseEntryDetails("vehType", { required: (userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 2), onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    >
        <option value=''>----Select-----</option>
        <option value='N'>New Vehicle / مركبة جديدة</option>
        <option value='U'>Used Vehicle / مركبة مستعملة</option>

    </select>
    let VehicleFinanced = <select className={errorUseEntryDetails.isVehicleFinanced ? 'form-select  is-invalid' : 'form-select'}
        name="isVehicleFinanced"
        data-toggle="select2"
        id="isVehicleFinanced"
        //disabled={true}
        {...registerUseEntryDetails("isVehicleFinanced", { required: (userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 2), onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    >
        <option value=''>----Select-----</option>
        <option value='Y'>Yes / نعم</option>
        <option value='N'>No / لا</option>

    </select>
    let VehCategory = <select className={errorUseEntryDetails.vehCategory ? 'form-select  is-invalid' : 'form-select'}
        name="vehCategory"
        data-toggle="select2"
        id="vehCategory"
        //disabled={true}
        {...registerUseEntryDetails("vehCategory", { required: (userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 3) || (userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 2), onChange: (e) => onChangeUseEntryDetailsParams(e) })}
    >
        <option value=''>----Select Vehicale Category-----</option>
        <option value='P'>Personal Vehicle / مركبة خاصة</option>
        <option value='C'>Company Vehicle / مركبة شركة</option>

    </select>
    return (
        <>
            {userEntry.isValidated === "Y" && <div><ul className="nav nav-tabs nav-bordered mb-3">
            </ul>
                <body /*data-layout-config="{&quot;darkMode&quot;:false}" data-layout-color="light"*/>

                    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-xxl-6 col-lg-5">
                                    <div class="card">

                                        <div class="card-body p-4">

                                            <span class="logo-lg d-block mb-3">
                                                <div class="text-center w-75 m-auto">
                                                    <h4 class="text-black text-center mt-0 mb-3 fw-bold"> Required Information / المعلومات المطلوبة</h4>
                                                </div>
                                            </span>
                                            <ul className="nav nav-tabs nav-bordered my-3">
                                            </ul>


                                            <form className="form-group needs-validation"
                                                onSubmit={submitUseEntryDetails(onUseEntryDetailsSubmit, onErrorUseEntryDetails)} noValidate="noValidate">

                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label">Mobile No / رقم الهاتف</label>
                                                    {UserMobileNo}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Name / الأسم</label>
                                                    {UserName}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Email / البريد الإلكتروني</label>
                                                    {UserEmail}
                                                    {errorUseEntryDetails.userEmail?.message && <span>{errorUseEntryDetails.userEmail?.message}</span>}

                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"> Product Type / نوع المنتج</label>
                                                    {UserProductTypeId}
                                                </div>

                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label">Service Type / نوع الخدمة المطلوبة</label>
                                                    {UserSserviceTypeId}
                                                </div>
                                                {(userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 2) && <div><div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Type / نوع المركبة</label>
                                                    {UserVehType}
                                                </div>
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="ltr-label"><span className='redstar'>*</span>Is the vehicle under bank finance / mortgage?  / هل المركبة مرهونة لدى البنك أو ممولة؟</label>
                                                        {VehicleFinanced}
                                                    </div>
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Category / فئة المركبة</label>
                                                        {VehCategory}
                                                    </div></div>}
                                                {(userEntryDetails.userProductTypeId == 982 && userEntryDetails.userSserviceTypeId == 3) &&
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Category / فئة المركبة</label>
                                                        {VehCategory}
                                                    </div>}
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Remarks / ملاحظات</label>
                                                    {UserRemarks}
                                                </div>

                                                {userEntryDetails.statusTypeId == 988 && <div className="mb-3 ">
                                                    <h3><span className='redstar'>Additional Information Remarks:- </span></h3>

                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'></span>{userEntryDetails.coreSystemRemarks}</label>
                                                </div>}
                                                <UserEntryDocumentsUpload />

                                                {userEntryDetails.agreeTerms != "Y" && <div class="mb-3">
                                                    <div class="form-check">
                                                        {TermsandConditions}
                                                        {userEntryDetails.prefLanguage === 'ENG' ? <label htmlFor="termsCheckbox" class="form-check text-justify" className="fs-6">
                         
                                                            
                                                       By consenting to this privacy notice, you are giving us permission to process your personal data specifically for the purposes identified. Consent is required for ASNIC to process all types of personal data, and it must be explicitly given. Where we request sensitive personal data, we are always obligated to inform you why the information is being collected and how it will be used.
                                                        By submitting the documents, you confirm that all documents and information provided by you are valid, accurate, and authentic.
                                                        You may withdraw your consent at any time by submitting a “Data Subject Consent Withdrawal Request” by writing to <a href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a>. Please note that it may take up to 30 days for us to process your request and provide confirmation.

                                                        </label>
                                                            :
                                                            <label htmlFor="termsCheckbox" class="form-check-label text-justify-custom" className="fs-6" 
                                                            style={{textAlign: "-webkit-right"}}>
                                                                                                {/* <span dir="rtl">
                                                                                                بموافقتك على إشعار الخصوصية هذا، فإنك تمنحنا الإذن لمعالجة بياناتك الشخصية للأغراض المحددة فقط. تُعد الموافقة مطلوبة لشركة الصقر الوطنية للتأمين     لمعالجة جميع أنواع البيانات الشخصية، ويجب أن يتم تقديمها بشكل صريح         وواضح. وفي حال طلب بيانات شخصية حساسة، فإننا ملتزمون دائمًا بإبلاغك          بسبب جمع هذه المعلومات وكيفية استخدامها. ومن خلال تقديمك للمستندات           فإنك تؤكد أن جميع المستندات والمعلومات المقدمة من قبلك صحيحة وسارية      وموثوقة. يمكنك سحب موافقتك في أي وقت من خلال تقديم "طلب سحب موافقة           صاحب البيانات" عبر مراسلتنا على يرجى العلم بأن معالجة الطلب <a href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a> وتزويدك       بالتأكيد قد تستغرق مدة تصل إلى 30 يومًا.
                                                                                                    </span> */}
                                                                    <span dir="rtl">
                                                                                  بموافقتك على إشعار الخصوصية هذا، فإنك تمنحنا الإذن لمعالجة بياناتك الشخصية للأغراض المحددة فقط. تُعد الموافقة مطلوبة لشركة الصقر الوطنية للتأمين لمعالجة جميع أنواع البيانات      الشخصية، ويجب أن يتم تقديمها بشكل صريح وواضح. وفي حال طلب بيانات شخصية حساسة، فإننا     ملتزمون دائمًا بإبلاغك بسبب جمع هذه المعلومات وكيفية استخدامها. ومن خلال تقديمك       للمستندات فإنك تؤكد أن جميع المستندات والمعلومات المقدمة من قبلك صحيحة وسارية وموثوقة.    يمكنك سحب موافقتك في أي وقت من خلال تقديم "طلب سحب موافقة صاحب البيانات" عبر مراسلتنا        على
                                                                    </span>
                                                                    <br />
                                                                    <a style={{float: "inline-end"}} href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a>
                                                                    <br />
                                                                    <span dir="rtl">
                                                                    يرجى العلم بأن معالجة الطلب وتزويدك بالتأكيد قد تستغرق مدة تصل إلى 30 يومًا.
                                                                    </span>
                                                                    <br />
                                                        </label>
                                                        }
                                                    </div>
                                                </div>}
                                                { <div class="mb-3">
                                                    <div class="">
                                                        {userEntryDetails.prefLanguage === 'ENG' ? <label htmlFor="termsCheckbox" class="text-justify" className="fs-6" 
                                                        style={{color: "crimson"}}>
                                
                                                       Kindly ensure to click '<strong>Submit</strong>' after saving the details.
                                                        </label>
                                                            :
                                                            <label htmlFor="termsCheckbox" class="form-check-label text-justify-custom" className="fs-6" 
                                                            style={{textAlign: "-webkit-right",  color: "crimson"}}>
                                                                    <span dir="rtl">
                                                                                  يرجى التأكد من الضغط على "<strong>Submit</strong>" بعد حفظ البيانات
                                                                    </span>                                                             
                                                        </label>
                                                        }
                                                    </div>
                                                </div>}
                                                
                                                {userEntryDetails.isSubmitted !== "Y" &&
                                                    <div id="tooltip-container2">
                                                        {userEntryDetails.validForSubmission == "Y" && <button type="button" className="btn btn-success float-end" onClick={() => onFinalSubmit()}
                                                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Save" ><i className="dripicons-save"></i> Submit</button>}

                                                        <button type="submit" className="btn btn-primary float-end"
                                                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Save" ><i className="dripicons-save"></i> Save</button>


                                                    </div>}
                                            </form>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </body></div>}
        </>
    )
}
